import { Button } from "ui/button";
import toast from "components/partials/toast/toast";
import CollegeProfileEmailTypeCard from "containers/admin/clients/client/college-profile-page/college-profile-email-type-card";
import CollegeProfileSectionHeader from "containers/admin/clients/client/college-profile-page/college-profile-section-header";

import { useEmailTypes, useTriggerEmailTypeSync } from "hooks/api/use-email-types";
import { useCurrentUser } from "hooks/api/use-current-user";

import { getErrorMessage } from "utilities";
import { hasPermission } from "utilities/user";

import { Permission } from "types/auth";

const CollegeProfileEmailTypesSection = ({ clientId }: { clientId: string }) => {
  const currentUser = useCurrentUser();
  const { data: emailTypes, isLoading, refetch: refetchEmailTypes } = useEmailTypes(clientId);
  const triggerEmailTypeSync = useTriggerEmailTypeSync();

  const canWriteClient = hasPermission(currentUser, Permission.PERM_CLIENT_WRITE);

  const handleSyncSuccess = async () => {
    await refetchEmailTypes();
    toast.success({
      data: { title: "Sync is done" },
    });
  };

  const handleSyncEmailTypes = () => {
    triggerEmailTypeSync.mutate(undefined, {
      onSuccess: () => {
        void handleSyncSuccess();
      },
      onError: (err) => {
        toast.error({
          data: {
            title: "Something went wrong",
            message: getErrorMessage(err) || "Please, try again",
          },
        });
      },
    });
  };

  return (
    <div className="flex flex-col gap-4">
      <CollegeProfileSectionHeader title="Email types">
        {canWriteClient && (
          <Button
            variant="outlined"
            size="medium"
            onClick={handleSyncEmailTypes}
            loading={triggerEmailTypeSync.isPending}
            data-testid="form-section-action-sync-email-types"
          >
            Sync email types
          </Button>
        )}
      </CollegeProfileSectionHeader>

      {isLoading && <p className="text-sm text-gray-500">Loading email types...</p>}

      {!isLoading && !emailTypes?.length && (
        <p className="text-base text-gray-500">There are no email types created yet.</p>
      )}

      {!isLoading && !!emailTypes?.length && (
        <div className="flex max-w-[600px] flex-col gap-3">
          {emailTypes.map((emailType) => (
            <CollegeProfileEmailTypeCard
              key={emailType.id}
              clientId={clientId}
              emailType={emailType}
              canEdit={canWriteClient}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CollegeProfileEmailTypesSection;
